import React from "react";
import { usePageHistoryStore } from "../stores/usePageHistoryStore";
import { formatDateTime } from "utils";

// Компонент елемента історії
const HistoryItem = ({ log }) => {
  // Отримуємо дані та дії зі стору
  const config = usePageHistoryStore((state) => state.config);

  // Витягуємо словники з конфігурації
  const actionTypeMap = config?.actionTypeMap || {};
  const renderPropertyChanges = config?.renderPropertyChanges || null;
  return (
    <li className="history-item">
      {/* Шапка: Хто, Що зробив, З чим */}
      <header className="history-item__header">
        <span className="history-item__user" title={log.username}>
          {log.username}
        </span>
        <span className="history-item__action">
          {actionTypeMap[log.action_type] || log.action_type}
        </span>
        <span className="history-item__identifier">{log.subject_identifier}</span>
      </header>

      {/* Тіло: Деталі змін */}
      <div className="history-item__body">
        {renderPropertyChanges ? renderPropertyChanges(log.properties) : null}
      </div>

      {/* Футер: Коли */}
      <footer className="history-item__footer">
        <span className="history-item__date">{formatDateTime(log.created_at)}</span>
      </footer>
    </li>
  );
};

export default HistoryItem;
